import {IHttpService} from "angular";
import {ProductHistoryRecords} from "../models/ProductHistoryRecord";
import {StripeProductHistory} from "../models/StripeProductHistory";
import {Optional} from "../../js/util/Optional";
import {StripeBillingRecord} from "../models/StripeBillingRecord";
import {StripeUserSubscriptionRecord, SubscriptionResponse} from "../models/StripeUserSubscriptionRecord";

export class UserStripeService {

    public static id = "userStripeService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async productHistory(): Promise<StripeProductHistory> {
        const url = "/tradefloor/api/stripe/product-history";
        const response = await this.$http.get<ProductHistoryRecords>(url);
        const records = response.data!;
        return StripeProductHistory.build(records);
    }

    public async currentSubscriptions(): Promise<Array<StripeUserSubscriptionRecord>> {
        const url = "/tradefloor/api/stripe/subscriptions";
        const response = await this.$http.get<SubscriptionResponse>(url);
        return Optional.of(response)
                       .map((r) => r.data)
                       .map((d) => d.subscriptions)
                       .orElse([]);
    }

    public async billingDetails(): Promise<StripeBillingRecord> {
        const url = "/tradefloor/api/stripe/billing";
        const response = await this.$http.get<StripeBillingRecord>(url);
        return response.data!;
    }
}
